import uuid from 'uuid/v4';
import { DiffMatchPatch } from '../../utils/diff-match-patch/diff-match-patch';
export const createDiffs = (a, b) => {
  const diff = DiffMatchPatch.diff_linesToWords_(a, b);
  const diffs = DiffMatchPatch.diff_main(diff.chars1, diff.chars2, false);
  DiffMatchPatch.diff_charsToLines_(diffs, diff.lineArray);
  return diffs.map(diff => ({
    type: diff[0],
    text: diff[1],
    length: diff[1].length
  }));
};
const normaliseType = (diff, nextDiff) => {
  if (diff.type === -1 && (nextDiff === null || nextDiff === void 0 ? void 0 : nextDiff.type) === 1) {
    // Lookahead 1 diff to see if the next diff is an Addition
    return 'REPLACEMENT';
  }
  // delete
  else if (diff.type === 1) {
    return 'DELETION';
  }
  // add
  else if (diff.type === -1 && (!nextDiff || nextDiff && nextDiff.type !== 1)) {
    return 'ADDITION';
  }
};
export const getDiffObjectsBetweenParagraphs = (paragraphsA, paragraphsB) => paragraphsA.reduce((acc, paragraph, index) => acc.concat(getDiffObjectsForParagraph(paragraph, paragraphsB[index].text)), []);
export const getDiffObjectsForParagraph = (originalParagraph, correctedParagraphText) => {
  const diffObjects = [];
  const originalText = originalParagraph.text;
  const diffs = createDiffs(originalText.trim(), correctedParagraphText.trim());
  const trimmingStartOffset = originalText.length - originalText.trimStart().length;
  let offset = originalParagraph.from + trimmingStartOffset;
  const n = diffs.length;
  for (let i = 0; i < n; i++) {
    const {
      type,
      text,
      length
    } = diffs[i];
    const finalType = normaliseType(diffs[i], diffs === null || diffs === void 0 ? void 0 : diffs[i + 1]);
    if (finalType === 'DELETION') {
      diffObjects.push({
        id: uuid(),
        from: 1 + offset,
        to: 1 + offset,
        type: finalType,
        text: text,
        originalText: text
      });
    } else if (finalType === 'REPLACEMENT' || finalType === 'ADDITION') {
      // Count how many inline nodes are overlapping with the word correction, and cater for them
      const inlineNodeOverlapCount = originalParagraph.inlineNodePositions.filter(pos => originalParagraph.from + pos <= offset + length && originalParagraph.from + pos >= offset).length;
      const inlineNodeOffsetCount = originalParagraph.inlineNodePositions.filter(pos => originalParagraph.from + pos < offset).length;
      const obj = {
        id: uuid(),
        from: 1 + offset + inlineNodeOffsetCount,
        to: 1 + offset + length + inlineNodeOffsetCount - inlineNodeOverlapCount,
        type: finalType,
        text: text,
        originalText: text
      };
      if (finalType === 'REPLACEMENT') {
        var _diffs$text, _diffs;
        const nextText = (_diffs$text = diffs === null || diffs === void 0 ? void 0 : (_diffs = diffs[i + 1]) === null || _diffs === void 0 ? void 0 : _diffs.text) !== null && _diffs$text !== void 0 ? _diffs$text : text;
        const shouldTrimEndingSpace = text.endsWith(' ') && nextText.endsWith(' ');
        obj.to += shouldTrimEndingSpace ? -1 : 0;
        obj.text = shouldTrimEndingSpace ? nextText.slice(0, -1) : nextText;
        obj.originalText = shouldTrimEndingSpace ? text.slice(0, -1) : text;
        i++;
      }
      diffObjects.push(obj);
    }

    // unchanged and removed words are part of original text
    if (type === 0 || type === -1) {
      offset += length;
    }
  }
  return diffObjects;
};